import React from "react";
import styled from "styled-components";

const Button = (props) => {
  const { title, disabled, onClick } = props;
  return (
    <Div>
      <NextButton disabled={disabled} onClick={onClick}>
        {title}
      </NextButton>
    </Div>
  );
};

const Div = styled.div`
  box-sizing: border-box;
  height: 83px;
  border: 1px solid #e6e7e8;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const NextButton = styled.button`
    width: 90vw;
    height 80%;
    border-radius: 4px;
    border-color: white;
    background-color: #345d9d;
    font-size: 16px;
    color: #FFFFFF;
    :disabled {
        opacity: 0.5;
    }
`;

export default Button;
